import { useStaticQuery, graphql } from "gatsby";

/**
 * Ítems de la navegación principal.
 *
 * "Productos" cuelga de la primera categoría, así que sin categorías se oculta
 * en vez de apuntar a /categoria/undefined. "Marcas", "Promociones" y
 * "Contacto" son anclas de la home y funcionan desde cualquier página.
 */
const useNavItems = () => {

	const categories = useStaticQuery(graphql`
        query NavCategories {
            allCategories(limit: 1, sort: {fields: category}) {
                nodes {
                    categorySlug
                }
            }
        }
    `).allCategories.nodes;

	const firstCategorySlug = categories[0]?.categorySlug;

	return [
		{ caption: "Inicio", href: "/" },
		...(firstCategorySlug
			? [{
				caption: "Productos",
				href: `/categoria/${firstCategorySlug}`,
				isCategoryLink: true
			}]
			: []),
		{ caption: "Marcas", href: "/#marcas" },
		{ caption: "Promociones", href: "/#promociones" },
		{ caption: "Contacto", href: "/#contacto" }
	];
};

export default useNavItems;
